import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import FieldSet from 'flarum/common/components/FieldSet';
import RealtimeUserPreferencesItems from './RealtimeUserPreferences';
export default function extendUserPreferences() {
  if (!!app.data['flarum-realtime.typing-indicator']) {
    extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
      const user = this.user;
      if (!user || !user.canViewWhoTypes()) {
        return;
      }
      items.add('realtimeItems', m(FieldSet, {
        className: "Settings-realtime",
        label: app.translator.trans('flarum-realtime.forum.user.settings.heading')
      }, RealtimeUserPreferencesItems(user).toArray()), 55);
    });
  }
}
flarum.reg.add('flarum-realtime', 'forum/extend/User/extendUserPreferences', extendUserPreferences);